// @flow
import React from 'react';

import Emojify from 'app/components/shared/Emojify';

import { shortCommit } from 'app/lib/commits';
import LegacyDispatcher from "app/lib/legacyDispatcher";

type Props = {
  job: {
    id: string,
    state: string,
    name: ?string,
    passed: boolean,
    triggerAsync: boolean,
    triggerBranch: string,
    triggerCommit: string,
    triggerCommitShortLength: number,
    triggerProject?: {
      name: string
    },
    triggeredBuild?: {
      number: number,
      destroyedAt?: string,
      url: string
    }
  }
};

export default class TriggerJobSummary extends React.PureComponent<Props> {
  wrapperNode: ?HTMLDivElement;

  componentDidMount() {
    setTimeout(
      () => {
        LegacyDispatcher.emit("job:expanded", {
          job: this.props.job,
          el: this.wrapperNode
        });
      },
      0
    );
  }

  render() {
    const buildNode = (
      this.props.job.triggeredBuild && (
        this.props.job.triggeredBuild.destroyedAt
          ? (
            <div>
              Build #
              {this.props.job.triggeredBuild.number}
              {" "}
              <span className="red">
                (Pipeline Deleted)
              </span>
            </div>
          )
          : (
            <div>
              <a href={this.props.job.triggeredBuild.url}>
                Build #
                {this.props.job.triggeredBuild.number}
              </a>
            </div>
          )
      )
    );

    const asyncNode = this.props.job.triggerAsync && (
      <span className="dark-gray italic">
        {" asynchronously"}
      </span>
    );

    const iconNode = (() => {
      if (this.props.job.state === "finished") {
        if (this.props.job.passed) {
          return (
            <span style={{ color: "#69A76A" }}>
              <i className="fa fa-check" />
            </span>
          );
        }

        return (
          <span style={{ color: "#A94442" }}>
            ✖
          </span>
        );
      } else if (this.props.job.state === "running") {
        return (
          <span style={{ color: "#ebbf25" }}>
            <i className="fa fa-refresh fa-spin" />
          </span>
        );
      } else if (this.props.job.state === "canceling") {
        return (
          <span style={{ color: "#A94442" }}>
            <i className="fa fa-refresh fa-spin" />
          </span>
        );
      } else if (this.props.job.state.indexOf("failed") > 0) {
      // no-icon
      } else if (this.props.job.state === "canceled") {
        return (
          <span style={{ color: "#A94442" }}>
            ✖
          </span>
        );
      } else if (this.props.job.state === "skipped") {
        return (
          <span style={{ color: "#8eaeba" }}>
            <i className="fa fa fa-minus-square" />
          </span>
        );
      } else {
        return (
          <span>
            <i className="fa fa-clock-o dark-gray" />
          </span>
        );
      }
    })();

    return (
      <div
        id={this.props.job.id}
        ref={(wrapperNode) => this.wrapperNode = wrapperNode}
        className="build-details-pipeline-trigger-job"
      >
        <div className="bold align-middle" style={{ lineHeight: "23px" }}>
          {iconNode}
          {" "}
          <Emojify
            text={this.props.job.name || "Trigger Build"}
          />
        </div>
        <div className="dark-gray">
          <code className="monospace">
            {this.props.job.triggerBranch}
          </code>
          {" \x2F "}
          <code className="monospace" title={this.props.job.triggerCommit}>
            {shortCommit(this.props.job.triggerCommit, this.props.job.triggerCommitShortLength)}
          </code>
          {" on "}
          <Emojify
            text={this.props.job.triggerProject && this.props.job.triggerProject.name || "unknown pipeline"}
          />
          {asyncNode}
        </div>
        {buildNode}
      </div>
    );
  }
}
